// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zuNy","top":"styles_top__2ppLW"};